import { Scope } from '@os-components';

export const BASKET_SCOPE_PROD: Scope = {
    api: 'BASKET',
    scopes: [
        'openid',
        'https://login.sew-eurodrive.com/75305880-5b75-4490-b918-aebae12328c4/Basket.Read',
        'offline_access',
    ],
};

export const WZ_SCOPE_PROD: Scope = {
    api: 'WZ',
    scopes: [
        'openid',
        'https://login.sew-eurodrive.com/057d8fbd-e788-4813-b701-a793281a46ff/FullAccess',
        'offline_access',
    ],
};
